module.exports = __webpack_public_path__ + "img/baiduMap.4bf1108b.png";